export enum ApprenticeProgressStatusEnum
{
    InProgress = 1,
    Done = 2,
    Sent = 3,
    Required = 4,
    NotRequired = 5
}
